import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Box from '@zenbusiness/zui/Box';
import Divider from '@zenbusiness/zui/Divider';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';

import { FaqItem } from './components/FaqItem';
import * as Styled from './FaqsSection.style';

import { useProductLandingContext } from '../../contexts/useProductLanding';

function FaqsSection() {
  const { productConfig } = useProductLandingContext();
  const { faqs: { title, items = [] } = {}, howItWorks, whatsIncluded, socialProof } = productConfig;

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      {(howItWorks || whatsIncluded || socialProof) && <Divider />}
      <Styled.Root>
        {title && (
          <Box sx={{ flex: 1 }}>
            <Heading size="xl" width={{ xs: '100%', lg: '50%' }}>
              <FormattedMessage id={title} />
            </Heading>
          </Box>
        )}
        <Stack sx={{ flex: 2 }} gap={2}>
          {items?.map((item) => (
            <FaqItem key={item.question} item={item} />
          ))}
        </Stack>
      </Styled.Root>
    </>
  );
}

export default FaqsSection;
